<template functional>
  <li class="menu-item" v-on="listeners">
    <h6 class="menu-header">
      <slot v-bind:text="props.text">
        <a
          :href="props.url"
          :target="props.openInNewTab ? '_blank' : null"
          :rel="props.openInNewTab ? 'noopener' : null"
          v-bind="props.anchorAttrs"
        >
          {{ props.text }}
        </a>
      </slot>
      <span class="has-arrow" />
    </h6>
  </li>
</template>

<script>
export default {
  name: 'NavMenuHeader',

  props: {
    /** Text which is to be shown in the component */
    text: {
      type: String,
      required: true
    },
    /** Link to redirect to on-click */
    url: {
      type: String,
      required: true
    },
    /** Boolean value which decides if the link is to be opened in a new tab or not */
    openInNewTab: {
      type: Boolean,
      default: false
    },
    /** Object value for additional attributes/properties for the nested anchor tag */
    anchorAttrs: Object
  }
}
</script>

<style lang="scss" scoped>
.menu-header {
  font-weight: 700;
  letter-spacing: 0.3px;
  margin-bottom: 3px;
  text-align: left;
  text-transform: uppercase;
  white-space: nowrap;
}

.has-arrow {
  border-top: 4px solid transparent;
  border-bottom: 4px solid transparent;
  border-left: 4px solid $red;
  display: inline-block;
}
</style>
